import {
  authenticatedGet,
  authenticatedPost,
  authenticatedPut,
  authenticatedDelete,
} from "../../api/authenticatedFetch";

// Optimization Programme (Board Report v2 SP3, Component B) — tracks recommender
// insights that have been promoted into a tracked committed/realized savings
// programme. Backend: GET/POST /api/v1/optimization-programme, PUT/GET/DELETE
// /api/v1/optimization-programme/{id} (see backend_go T4/T5). Responses are wrapped
// under the "optimization_programme" (list) / "item" (single) envelope keys — unwrap
// here so callers just get plain arrays/objects.
export const listProgramme = async () => {
  const data = await authenticatedGet("/api/v1/optimization-programme");
  return data.optimization_programme || [];
};

export const createProgrammeItem = async (body) => {
  const data = await authenticatedPost("/api/v1/optimization-programme", body);
  return data.item;
};

export const updateProgrammeItem = async (id, body) => {
  const data = await authenticatedPut(`/api/v1/optimization-programme/${id}`, body);
  return data.item;
};

export const deleteProgrammeItem = async (id) => authenticatedDelete(`/api/v1/optimization-programme/${id}`);

// listCandidates fetches recommender insights that are candidates for promotion into
// the programme. NOTE — real-data limitation: /get-insights does not expose a
// recommender `name`; when promoting (see OptimizationProgrammePage's handlePromote),
// recommendation_ref is seeded from resource_md5 (falling back to id) since that's the
// best available identifier. A perfect match against the dbt int_f_insights join is a
// deploy-data nicety, not guaranteed here — the created programme item still stands on
// its own regardless.
export const listCandidates = async () => {
  const data = await authenticatedGet("/get-insights");
  return data.Insights || [];
};
